import * as React from "react";
const ToggleOnSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 9 7", fill: "currentColor", width: size || "9", height: size || "7", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.2 4 1.2 2 0 3.2 3.2 6.5 8.5 1.2 7.2 0z" }));
ToggleOnSmall.displayName = "ToggleOnSmall";
var ToggleOnSmall_default = ToggleOnSmall;
export {
  ToggleOnSmall_default as default
};
